"use client";

import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  num: "01",
  title: "Submit Property Details",
  desc: "Provide the location and basic specs of your vacant land. Our streamlined digital form takes less than five minutes to complete."
}, {
  num: "02",
  title: "Professional Valuation",
  desc: "Our land specialists conduct a data-driven analysis of your acreage, market trends, and property potential to ensure maximum value."
}, {
  num: "03",
  title: "Guaranteed Cash Offer",
  desc: "Receive a firm, no-obligation cash offer. No contingencies, no appraisals, and no hidden fees—just a clear path to liquidity."
}, {
  num: "04",
  title: "Rapid Closing & Payment",
  desc: "We handle all title work and closing costs. Choose your closing date and receive your funds via secure wire transfer or check."
}];
export default function StreamlinedSuccessPath() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="122938" id="the-land-exit-strategy" className="py-24 bg-background text-foreground relative overflow-hidden dark" ref={ref}>
      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes march-horizontal {
            to { stroke-dashoffset: -24; }
          }
          @keyframes march-vertical {
            to { stroke-dashoffset: -24; }
          }
          #the-land-exit-strategy {
            background-image: radial-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px);
            background-size: 32px 32px;
          }
        `
    }} />

      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-sans font-extrabold tracking-tighter text-foreground mb-4 uppercase">
            The Land Exit Strategy
          </h2>
          <p className="text-lg font-sans text-muted-foreground">
            A precision-engineered 4-step process designed for landowners seeking a fast, reliable, and entirely transparent cash exit.
          </p>
        </div>

        <div className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <svg className="absolute top-[4.5rem] left-[12.5%] w-[75%] h-2 hidden lg:block -z-10" preserveAspectRatio="none" aria-hidden="true">
            <line x1="0" y1="4" x2="100%" y2="4" stroke="var(--color-primary)" strokeWidth="2" strokeDasharray="8 4" style={{
            animation: 'march-horizontal 1s linear infinite'
          }} opacity="0.6" />
          </svg>

          {}
          <svg className="absolute top-[12.5%] left-1/2 -translate-x-1/2 w-2 h-[75%] lg:hidden -z-10" preserveAspectRatio="none" aria-hidden="true">
            <line x1="4" y1="0" x2="4" y2="100%" stroke="var(--color-primary)" strokeWidth="2" strokeDasharray="8 4" style={{
            animation: 'march-vertical 1s linear infinite'
          }} opacity="0.6" />
          </svg>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-6 relative z-10">
            {steps.map((step, i) => <Card key={i} data-index={i} className="group bg-card/40 backdrop-blur-md hover:bg-secondary transition-all duration-500 border-border/50 shadow-sm hover:shadow-xl relative overflow-hidden h-full rounded-sm">
                <CardHeader className="pb-4 relative z-10">
                  <div className="text-6xl font-mono font-black text-transparent [-webkit-text-stroke:1px_var(--color-primary)] opacity-30 group-hover:opacity-100 group-hover:text-primary group-hover:[-webkit-text-stroke:0px] transition-all duration-500 mb-6 inline-block">
                    {step.num}
                  </div>
                  <CardTitle className="text-xl font-sans font-bold text-foreground group-hover:text-primary transition-colors duration-300 tracking-tight">
                    {step.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground font-sans leading-relaxed text-sm">
                    {step.desc}
                  </p>
                </CardContent>
                
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/0 via-primary/0 to-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}